export const isIntuit = () =>
  window.STORYBOOK_ENV
    ? /selectedKind=Intuit[^&]*/.test(window.location.search)
    : window.partner === "intuit" || window.location.pathname.slice(0, 7) === "/intuit";

export default isIntuit;

export const isOauthCallback = () => window.location.pathname === "/quickbooks/oauth_callback";
